import { render, staticRenderFns } from "./workerAdd.vue?vue&type=template&id=67dffbf2&scoped=true&"
import script from "./workerAdd.vue?vue&type=script&lang=js&"
export * from "./workerAdd.vue?vue&type=script&lang=js&"
import style0 from "./workerAdd.vue?vue&type=style&index=0&id=67dffbf2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dffbf2",
  null
  
)

export default component.exports